module.exports = __webpack_public_path__ + "img/6523e4f711a532d90a4f3d97_isae3000-type1.28bf5e61.webp";